import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService, StockplaceItem } from '../../../services/logistic.service';

@Component({
  selector: 'tt-shipment-containers',
  templateUrl: './shipment-containers.component.html',
  styleUrls: ['./shipment-containers.component.css']
})
export class ShipmentContainersComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListStockPlaces: StockplaceItem[] = [];

    public selectListStatuses: StatusItem[] = [];

    public itemsListContainers: Item[] = [];

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(771))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadStatuses() {
        this.selectListStatuses = await this.datatask.Post(772);
    }

    private async loadStockPlaces() {
        if (!this.setting) return;

        return this.selectListStockPlaces = await this.logistic.getStockplaces({ businessco_no: this.setting.businessco_no_to });
    }

    private async loadShipmentContainers() {
        if (!this.setting) return;

        return this.itemsListContainers = await this.datatask.Post(773, this.setting);
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no_to':
                Promise.all([
                    this.loadStockPlaces()
                ]).then(() => {
                    this.loadShipmentContainers();
                    Promise.resolve();
                });
                break;
            case 'stockplace_id_to':
            case 'shipmentcontainerstatus_keyno':
                this.loadShipmentContainers();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadStatuses();
        this.loadStockPlaces();
        this.loadShipmentContainers();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no_to: string;
    stockplace_id_to: string;
    shipmentcontainerstatus_keyno: string;
}

interface StatusItem {
    shipmentcontainerstatus_keyno: string;
    shipmentcontainerstatus_name: string;
}
